import styles from "./InfoMessage.module.scss";

export default function InfoMessage({ text }) {
	return (
		<p className={styles.infoMessage}>
			<strong>{text}</strong>
		</p>
	);
}
